export default __webpack_public_path__ + "static/heroloop-33d83d683e9cd40aa80de1446b696f5c.mp4";